import { render, staticRenderFns } from "./EditQuestion.vue?vue&type=template&id=acf5ba5c"
import script from "./EditQuestion.vue?vue&type=script&lang=ts"
export * from "./EditQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports